import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.content}>
      <p className={styles.copy}>© 2026 SportsMaster. All rights reserved.</p>
      <div className={styles.links}>
        <Link to="/aboutus"   className={styles.link}>About Us</Link>
        <Link to="/contactus" className={styles.link}>Contact Us</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
